import { useEffect } from "react";
import { api } from "@/lib/api";

const HEARTBEAT_MS = 60 * 1000; // 60 seconds

/**
 * Pings POST /me/heartbeat every 60 seconds while the tab is visible.
 * Mounted globally for authenticated users (see App.js).
 *
 * Skipped silently if the user is not logged in (the endpoint will 401
 * which we swallow). Stops on tab hidden, restarts on visibility back.
 */
export function useHeartbeat(enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;

    let timer = null;

    const ping = async () => {
      if (document.visibilityState !== "visible") return;
      try {
        await api.post("/me/heartbeat");
      } catch {
        // 401 / network — ignore silently
      }
    };

    const start = () => {
      if (timer) return;
      ping(); // immediate
      timer = setInterval(ping, HEARTBEAT_MS);
    };
    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };
    const onVisibility = () => {
      if (document.visibilityState === "visible") start();
      else stop();
    };

    start();
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      stop();
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [enabled]);
}
